import React from 'react';
import { Row, Col, Spin, theme } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { Container } from '../../../components/CssFrameworkComponents';
import ButtonWithRole from '../../../components/ButtonWithRole';
import { BILLING_WRITE_REFUSED_ROLES } from '../../auth/roleCapabilities';
import { useSubscriptionState } from '../PlanStatus';
import { usePaymentChargebeeInfo } from '../hooks/usePaymentChargebeeInfo';

const BillingPayment = () => {
  const { token } = theme.useToken();
  const { onChangeBillingAddress, onChangePaymentMethod } = usePaymentChargebeeInfo();
  const [_, paymentMethodState] = useSubscriptionState();

  return (
    <Container fluid addClass={'p-0'}>
      <h3 className="">Payment Settings</h3>
      <p className="text-base text-grey">Update your billing details below.</p>
      <Row gutter={12}>
        <Col xs={24} lg={12}>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title text-base fw-bold">Billing Address</h5>
                {!paymentMethodState.isLoading && (
                  <>
                    {!paymentMethodState.isAddressValid ? (
                      <ExclamationCircleOutlined style={{ color: token.colorError }} />
                    ) : (
                      <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                    )}
                  </>
                )}
                {paymentMethodState.isLoading ? <Spin /> : null}
              </div>
              {!paymentMethodState.isLoading && (
                <p className="card-text fw-light">
                  {!paymentMethodState.isAddressValid
                    ? 'Please add your billing address.'
                    : 'A billing address is set.'}
                </p>
              )}

              {!paymentMethodState.isLoading && (
                <>
                  <hr />
                  <ButtonWithRole
                    disabledFor={BILLING_WRITE_REFUSED_ROLES}
                    onClick={onChangeBillingAddress}
                    block
                  >
                    {!paymentMethodState.isAddressValid ? 'Add' : 'Change'}
                  </ButtonWithRole>
                </>
              )}
            </div>
          </div>
        </Col>
        <Col xs={24} lg={12}>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title text-base fw-bold">Payment Method</h5>
                {!paymentMethodState.isLoading && (
                  <>
                    {!paymentMethodState.isCreditCardValid ? (
                      <ExclamationCircleOutlined style={{ color: token.colorError }} />
                    ) : (
                      <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                    )}
                  </>
                )}
                {paymentMethodState.isLoading ? <Spin /> : null}
              </div>
              {!paymentMethodState.isLoading && (
                <p className="card-text fw-light">
                  {!paymentMethodState.isPaymentMethodSet && 'Please add your preferred payment method.'}

                  {paymentMethodState.isPaymentMethodSet &&
                    (paymentMethodState.isCreditCardValid
                      ? 'A payment method is set.'
                      : 'Your payment method is invalid, please check your card details.')}
                </p>
              )}
              {!paymentMethodState.isLoading && (
                <>
                  <hr />
                  <ButtonWithRole
                    disabledFor={BILLING_WRITE_REFUSED_ROLES}
                    onClick={onChangePaymentMethod}
                    block
                  >
                    {!paymentMethodState.isPaymentMethodSet ? 'Add' : 'Change'}
                  </ButtonWithRole>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default BillingPayment;
